import get from 'lodash.get';

const getStatus = (rootState) => get(rootState, 'status', {});

export default getStatus;
